export class QuoteRequest {
    id;
    inputMint;
    outputMint;
    swapMode;
    slippage;
    referralFee;
    referralFeeTarget;
    userPublicKey;
    constructor(id, inputMint, outputMint, swapMode, slippage, userPublicKey, referralFee = 0, referralFeeTarget = "") {
        this.id = id;
        this.inputMint = inputMint;
        this.outputMint = outputMint;
        this.swapMode = swapMode;
        this.slippage = slippage;
        this.userPublicKey = userPublicKey;
        this.referralFee = referralFee;
        if (referralFeeTarget !== "")
            this.referralFeeTarget = referralFeeTarget;
    }
}
export class QuoteResponse {
    routes;
    slot;
    constructor(routes, slot) {
        this.routes = routes;
        this.slot = slot;
    }
}
